// extracted by mini-css-extract-plugin
module.exports = {"block":"_1891","label":"_6091","arrow":"_7369"};